import React from 'react';

import styles from './WatchlistSelection.css';

import {
    ADD_WATCHLIST_FUND,
    REMOVE_WATCHLIST_FUND
} from '../../utils/watchlist-settings';

const WatchlistCheckbox = ({
    key,
    closeModal = () => {},
    dispatchWatchlist = () => {},
    i = null,
    funds,
    watchlist = {}
}) => {
    const { displayName } = watchlist;

    const doesWatchlistHaveFunds = () => {
        let fundFound = false;
        if (!(watchlist.items && watchlist.items.length)) return fundFound;
        if (!funds) return fundFound;

        watchlist.items.forEach((item) => {
            if (funds.length && funds.includes(item.ticker)) fundFound = true;
            else if (funds === item.ticker) fundFound = true;
        });
        return fundFound;
    };

    const toggleFund = (hasFund) => {
        dispatchWatchlist(
            !hasFund
                ? {
                      type: ADD_WATCHLIST_FUND,
                      selectedWatchlist: watchlist,
                      funds
                  }
                : {
                      type: REMOVE_WATCHLIST_FUND,
                      selectedWatchlist: watchlist,
                      funds
                  }
        );
        closeModal();
    };

    const hasFund = doesWatchlistHaveFunds();

    const checkboxId = `checkbox-${displayName}`;

    return (
        <div className="modal-row" key={key}>
            <label
                data-metrics-type="DD"
                className="watchlist-button add-fund-button"
                htmlFor={checkboxId}
            >
                <input
                    id={checkboxId}
                    type="checkbox"
                    checked={hasFund}
                    onClick={() => toggleFund(hasFund)}
                    onKeyPress={() => toggleFund(hasFund)}
                    tabIndex={i}
                />
                {displayName}
            </label>
            <style jsx>{styles}</style>
        </div>
    );
};

export default WatchlistCheckbox;
